<template v-if="superAdminUser">
  <v-card class="mt-3 pa-4">
    <h3 class="calculation-title">Permissions</h3>
    <v-simple-table dense :loading="loading">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left title-padding">
          </th>
          <th class="text-left title-padding" v-for="constant in p" :key="`constant_${constant}`">
            {{ capitalizeWords(constant) }}
          </th>
        </tr>
        </thead>
        <tbody>
        <td >
        </td>
        <user-permission-table v-for="(value, key) in permissions" :key="`permission_${key}`"
                               :item="key" :userPermissions="userPermissions"/>
        </tbody>
      </template>
    </v-simple-table>
    <v-btn @click="handleSaveClick" class="mt-5" color="success">Save</v-btn>
  </v-card>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {PermissionsConstants} from "@/permissions";
import UserPermissionTable from "@/components/user/UserPermissionTable";

export default {
  name: "UserPermissions",
  components: {
    'user-permission-table': UserPermissionTable
  },
  data() {
    return {
      p: PermissionsConstants,
      superAdminUser: false
    }
  },
  computed: {
    ...mapState('user', ['permissions', 'userPermissions', 'loading']),
    ...mapState('auth', ['user']),
  },
  mounted() {
    if (this.user.role === 'super_admin') {
      this.superAdminUser = true
    }
  },
  methods: {
    ...mapActions('user', ['updateUserPermissions', 'fetchAllPermissions']),
    capitalizeWords(arr) {
        return arr.charAt(0).toUpperCase() + arr.slice(1).toLowerCase();
    },
    async handleSaveClick(){
      await this.updateUserPermissions()
      await this.fetchAllPermissions()
    }
  }
}
</script>

<style scoped>

</style>